var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-select" }, [
    _c(
      "div",
      { staticClass: "group-select-title" },
      [
        _c("Title", {
          attrs: { title: _vm.$t("pc_biz_group_move_group" /* 移动分组 */) },
          on: { close: _vm.onCancel },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "group-select-content" }, [
      _c("span", { staticClass: "group-select-content__info" }, [
        _vm._v(
          _vm._s(
            _vm.$t("pc_biz_group_move_info", [
              _vm.selectedUserIds.value ? _vm.selectedUserIds.value.length : 0,
            ]) /*`将选中的 ${} 人移动至：`*/
          )
        ),
      ]),
      _c(
        "div",
        {
          class: {
            "group-select-content-new": true,
            "group-select-content-new--line": _vm.groupList.length,
          },
        },
        [
          _c(
            "span",
            {
              class: {
                "group-select-content-new__btn": true,
                "group-select-content-new__btn--active": _vm.groupId === "new",
              },
              on: {
                click: function ($event) {
                  return _vm.onSelect("new")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_group_add" /* 新的分组 */)))]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "group-select-content-list" },
        [
          _c("GroupList", {
            attrs: {
              "group-list": _vm.groupList,
              id: _vm.groupId,
              mode: "select",
            },
            on: { select: _vm.onSelect },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "group-select-footer" },
      [_c("Submit", { on: { cancel: _vm.onCancel, submit: _vm.onSubmit } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }